import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});
const Laroute = require('../../laroute');

export default {
    namespaced: true,

    state: {
        providers: [],
        importItems: [],
        provider: null,
        integrationProcessing: false,
    },

    getters: {
        getProviderByName: state => name => {
            const provider = state.providers.find(p => p.name);

            return provider || null;
        },
    },

    mutations: {
        [types.SET_PROVIDER_LIST](state, providers) {
            state.providers = providers;
        },

        [types.SET_IMPORT_ITEMS](state, items) {
            state.importItems = items;
        },

        [types.SET_PROVIDER](state, provider) {
            state.provider = provider;
        },

        [types.SET_INTEGRATION_PROCESSING](state, integration_processing) {
            state.integrationProcessing = integration_processing;
        },
    },

    actions: {
        async getProviders({ dispatch, commit }) {
            const url = Laroute.route('settings.integrations.providers');
            startLoading(dispatch, 'fetch-providers');

            try {
                const { data } = await axios.get(url);
                commit(types.SET_PROVIDER_LIST, data);
                endLoading(dispatch, 'fetch-providers');

                return data;
            } catch (e) {
                endLoading(dispatch, 'fetch-providers');
                throw e;
            }
        },

        setImportItems({ commit }, items) {
            commit(types.SET_IMPORT_ITEMS, items);
        },

        setProvider({ commit }, provider) {
            commit(types.SET_PROVIDER, provider);
        },

        processImportItems({ commit, state, dispatch }) {
            const api = Laroute.route('settings.integrations.sync_items');
            const options = {
                items: state.importItems,
                provider: state.provider.name,
            };

            startLoading(dispatch, 'loader');
            axios.post(api, options).then(res => {
                commit(types.SET_INTEGRATION_PROCESSING, true);
            });
        },

        setIntegrationProcessing({ commit }, status) {
            commit(types.SET_INTEGRATION_PROCESSING, status);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/provider.js